import { Box, CircularProgress, Container, Grid } from "@mui/material";
import OutlinedButton from "../OutlinedButton";
import SectionHeader from "../SectionHeader";
import Artist from "../Artist";
import { useMemo, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useArtists } from "../../hooks/useArtists";
import { useInView } from "react-intersection-observer";
import styles from "./styles";


const Artists = ({ isLandingPage }) => {
  const { data: artistsQuery, loadMore, isLoading, hasMore } = useArtists();
  const navigate = useNavigate();
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.05 });

  const allArtists = useMemo(
    () => (isLandingPage ? artistsQuery.slice(0, 3)  : artistsQuery),
    [artistsQuery, isLandingPage]
  );

  const handleClick = useCallback(() => {
    if (isLandingPage) {
      navigate("/artists");
      return;
    }
    loadMore();
  }, [isLandingPage, navigate, loadMore]);

  return (
    <Container maxWidth="lg"><Grid container>
      <SectionHeader
        title={"Artists"}
        description={"Below you can find our artists"}
      />
      <Box
        ref={ref}
        sx={styles.getGridSx(isLandingPage, inView)}
      >
        {allArtists?.map(({ imageURL, name, stageName, _id }) => (
          <Artist
            key={_id}
            image={imageURL}
            name={name}
            stageName={stageName}
            id={_id}
          />
        ))}
      </Box>
      <Box sx={styles.buttonWrapperSx}>
        <OutlinedButton
          onClick={handleClick}
          disabled={isLandingPage ? false : !hasMore || isLoading}
          sx={styles.buttonSx}
        >
          {isLoading ? <CircularProgress size={20} sx={styles.progressSx} /> : (isLandingPage ? "VIEW ALL" : "LOAD MORE")}
        </OutlinedButton>
      </Box>
    </Grid></Container>
  );
};

export default Artists;
